import { ReportSummaryMapping } from '../../../../components/report/redesigned';
import { ReportSummaryInterface } from '../../../common/ReportSummaryInterface';

export interface SpaceUsageSummary extends ReportSummaryInterface {
  totalOverageSpaces: number;
  totalChargedOverages: number;
  totalUnchargedOverages: number;
}

export const adminSpaceUsageSummaryMapping = [
  { id: 'totalOverageSpaces', label: 'Total Overage Spaces', formatter: 'number' },
  { id: 'totalChargedOverages', label: 'Total Charged Overages', formatter: 'number' },
  { id: 'totalUnchargedOverages', label: 'Total Un-Charged Overages', formatter: 'number' },
] satisfies ReportSummaryMapping[];